import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import { AutoAwesome as EmbeddingIcon } from '@mui/icons-material';

interface ConfirmCreateColumnEmbeddingDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedCount: number;
  generating: boolean;
}

const ConfirmCreateColumnEmbeddingDialog: React.FC<ConfirmCreateColumnEmbeddingDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedCount,
  generating,
}) => {
  return (
    <Dialog
      open={open}
      onClose={generating ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <EmbeddingIcon color="primary" fontSize="large" />
          <Typography variant="h6">Confirmar Generación de Embeddings</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          ¿Está seguro que desea generar embeddings para las columnas seleccionadas?
        </Typography>
        <Box
          sx={{
            p: 2,
            backgroundColor: '#f5f5f5',
            borderRadius: 1,
            borderLeft: '4px solid #1976d2',
          }}
        >
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Columnas seleccionadas:
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            {selectedCount} {selectedCount === 1 ? 'columna' : 'columnas'}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Este proceso puede tardar unos momentos.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={generating}
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={generating}
          startIcon={generating ? <CircularProgress size={20} /> : null}
        >
          {generating ? 'Generando...' : 'Generar Embeddings'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmCreateColumnEmbeddingDialog;
